import * as z from "zod";

const base64ImagePattern =
  /^data:image\/(jpg|avif|svg|webp|jpeg|png|gif);base64,.*$/;
const MAX_SIZE = 5 * 1024 * 1024;

export const gameSchema = z.object({
  universeId: z.number(),
  name: z.string(),
  thumbnail: z.string(),
  creator: z.string(),
  playerCount: z.number().optional(),
});

export const createScriptSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Description is required"),
  images: z
    .array(
      z
        .string()
        .regex(
          base64ImagePattern,
          "Image must be a base64 string of a jpg, avif, svg, webp, jpeg, png, or gif file",
        ),
    )
    .min(1, "Images must be an array of 1 to 3 elements")
    .max(3, "Images must be an array of 1 to 3 elements"),
  tags: z.array(z.string()),
  games: z.array(gameSchema).optional(),
  source: z
    .string()
    .min(1, "Source is required")
    .max(MAX_SIZE, "Source must be less than 5MB"),
  mobile: z.boolean(),
  key_system: z.boolean(),
  payment: z.enum(["Free", "Paid"], {
    errorMap: () => ({
      message: "Payment must be of type string and one of 'Free', 'Paid'",
    }),
  }),
});

export const reportScriptSchema = z.object({
  title: z
    .string()
    .min(3, "Title must be at least 3 characters long")
    .max(200, "Title must be at most 200 characters long"),
  content: z
    .string()
    .min(3, "Content must be at least 3 characters long")
    .max(2000, "Content must be at most 2000 characters long"),
  image: z.string().url().optional(),
});
